import {
  DialogTrigger,
  GhostIconButton,
  Icon,
  Popover,
  PopoverContent,
  PopoverHeading,
  Stack,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";
import { useCheckCardContext } from "../CheckCardContext";

type Props = React.PropsWithChildren<object>;

export function OrderingCheckCardHeader(props: Props) {
  const { t } = useTranslation();
  const {
    isReadOnly,
    isErrorOrInfoType,
    isCardSelected,
    isDisabled,
    isErrorType,
    checkOrderingError,
    checkCardConfig,
    testID,
    showRemoveWhenSelected,
    onRemove,
    isRequiredCheck = false,
  } = useCheckCardContext();

  return (
    <div className={styles.topSection}>
      {props.children}
      {!isReadOnly && (
        <Stack
          className={css(
            styles.icon,
            { padding: isErrorType ? undefined : "var(--space-1-5)" },
            css({
              background: `var(--${checkCardConfig.iconBackground})`,
            })
          )}
        >
          {showRemoveWhenSelected &&
          isCardSelected &&
          onRemove &&
          !isRequiredCheck ? (
            <button
              type="button"
              className={styles.removeButton}
              onClick={(event) => {
                event.stopPropagation();
                onRemove();
              }}
              aria-label={t("Remove")}
              data-testid={`${testID}-remove-button`}
            >
              <Icon
                type="standard"
                name="delete"
                size="space-5"
                color="icon-inverse"
                testID={`${testID}-delete-icon`}
              />
            </button>
          ) : isErrorOrInfoType &&
            !isCardSelected &&
            (isDisabled || isErrorType) ? (
            <DialogTrigger>
              <GhostIconButton
                testID="show-disabled-check-popover"
                icon="lock"
                size="small"
              />
              <Popover>
                {isErrorType && (
                  <PopoverHeading>{checkOrderingError?.title}</PopoverHeading>
                )}
                <PopoverContent>{checkOrderingError?.message}</PopoverContent>
              </Popover>
            </DialogTrigger>
          ) : (
            checkCardConfig.icon(testID)
          )}
        </Stack>
      )}
    </div>
  );
}

const styles = {
  icon: css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "var(--border-radius-half)",
  }),
  topSection: css({
    display: "flex",
    gap: "var(--space-2)",
    padding: "var(--space-2) var(--space-3) var(--space-2) var(--space-4)",
    alignItems: "flex-start",
  }),
  removeButton: css({
    background: "transparent",
    border: "none",
    color: "inherit",
    cursor: "pointer",
    display: "flex",
    padding: 0,
  }),
};
